// Presentation only: Shopify Forms retains its inputs, validation and submission.
const newsletterStyles = `
  #app-embed [data-testid="form"] {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 46px;
    gap: 0;
    width: 100%;
    box-sizing: border-box;
  }
  #app-embed [data-testid="form"] > div:has(shop-lead-capture) { grid-column: 1 / -1; }
  #app-embed [data-testid="form"] > div:has(> #email) {
    grid-column: 1;
    grid-row: 2;
    min-width: 0;
    margin: 0;
  }
  #app-embed [data-testid="form"] #email {
    width: 100%;
    min-height: 48px;
    box-sizing: border-box;
    border: 0;
    border-radius: 999px 0 0 999px;
    box-shadow: none;
    background: #fff;
    color: #14382e;
  }
  #app-embed [data-testid="form"] #email:focus { outline: none; box-shadow: none; }
  #app-embed [data-testid="btn-form-submit"] {
    grid-column: 2;
    grid-row: 2;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    min-width: 0;
    min-height: 48px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0 999px 999px 0;
    box-shadow: none;
    background: #fff;
    color: #14382e;
    font-size: 0;
  }
  #app-embed [data-testid="btn-form-submit"]::after {
    content: '';
    width: 20px;
    height: 20px;
    background: currentColor;
    mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M3 10h13m-5-5 5 5-5 5' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / contain no-repeat;
  }
  #app-embed [data-testid="btn-form-submit"]:hover { background: #fff; color: #006b50; }
  #app-embed [data-testid="btn-form-submit"][aria-disabled="true"]::after { display: none; }
  #app-embed [data-testid="form"] > [role="alert"] { grid-column: 1 / -1; }
`;

class DooboNewsletterStyle extends HTMLElement {
  connectedCallback() {
    this.attempts = 0;
    this.observer = new MutationObserver(() => this.styleForm());
    this.observer.observe(this, { childList: true, subtree: true });
    this.timer = setInterval(() => {
      this.styleForm();
      if (++this.attempts >= 300) clearInterval(this.timer);
    }, 100);
    this.styleForm();
  }

  styleForm() {
    const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
    if (!root || root.querySelector('[data-doobo-newsletter-style]')) return;
    const form = root.querySelector('[data-testid="form"]');
    if (!form?.querySelector('#email')) return;
    // If the merchant adds extra fields, leave the official layout intact.
    if (form.querySelectorAll('input:not([type="hidden"])').length !== 1) return;
    const style = document.createElement('style');
    style.dataset.dooboNewsletterStyle = '';
    style.textContent = newsletterStyles;
    root.append(style);
    clearInterval(this.timer);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    clearInterval(this.timer);
  }
}

if (!customElements.get('doobo-newsletter-style')) {
  customElements.define('doobo-newsletter-style', DooboNewsletterStyle);
}
